'use client';

import { c as _c } from "react/compiler-runtime";
import { Chip } from '@sprd/sprd-component-kit/v2';
import { useQuery } from '@tanstack/react-query';
import { useId, useState } from 'react';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import Pagination from '@/components/Pagination/Pagination';
import { Stars } from '@/components/Stars/Stars';
import { ALL_RATINGS } from '@/utility/constants';
import { Locale } from '@/utility/locale';
import { getProductReviewQueryOptions, initialReviewsFilter } from '@/utility/productReviewQueryOptions';
type ProductReviewsProps = {
  className?: string;
  productTypeId: string;
  locale: Locale;
};
const OFFSET_STEP = 10;
export const ProductReviews = props => {
  const $ = _c(43);
  const {
    className,
    productTypeId,
    locale
  } = props;
  const t = useTranslations();
  const id = useId();
  const [reviewsFilter, setReviewsFilter] = useState(initialReviewsFilter);
  const page = reviewsFilter.offset / OFFSET_STEP;
  let t0;
  if ($[0] !== locale || $[1] !== productTypeId || $[2] !== reviewsFilter) {
    t0 = getProductReviewQueryOptions(productTypeId, locale, reviewsFilter);
    $[0] = locale;
    $[1] = productTypeId;
    $[2] = reviewsFilter;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== t0) {
    t1 = {
      ...t0,
      placeholderData: _temp
    };
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    data,
    error,
    isFetching
  } = useQuery(t1);
  const allRatingPages = Math.ceil((data?.reviewCount ?? 0) / OFFSET_STEP);
  let t2;
  if ($[6] !== allRatingPages || $[7] !== reviewsFilter) {
    let t3;
    if ($[9] !== reviewsFilter) {
      t3 = (_, index) => ({
        onClick: () => setReviewsFilter({
          ...reviewsFilter,
          offset: index * OFFSET_STEP
        })
      });
      $[9] = reviewsFilter;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = Array.from({
      length: allRatingPages
    }, t3);
    $[6] = allRatingPages;
    $[7] = reviewsFilter;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const pagesWithIndex = t2;
  if (error) {
    return null;
  }
  const commentsAvailable = data?.comments && data.comments.length > 0;
  let t3;
  if ($[11] !== t) {
    t3 = t("reviews.filterByRating");
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = <p className="text-sm font-medium">{t3}</p>;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== isFetching || $[16] !== reviewsFilter.selectedRating) {
    t5 = ALL_RATINGS.split(",").map(rating => {
      const selected = rating === reviewsFilter.selectedRating;
      return <Chip key={`rating-filter-${rating}`} selected={selected} asChild={true}><button onClick={() => setReviewsFilter({
          offset: 0,
          selectedRating: selected ? ALL_RATINGS : rating
        })} aria-disabled={isFetching}>{rating}</button></Chip>;
    });
    $[15] = isFetching;
    $[16] = reviewsFilter.selectedRating;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t5) {
    t6 = <div className="inline-flex gap-2">{t5}</div>;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t4 || $[21] !== t6) {
    t7 = <div className="flex flex-col gap-2 py-4">{t4}{t6}</div>;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== isFetching) {
    t8 = clsx("flex flex-col gap-2 py-4", {
      "opacity-50": isFetching
    });
    $[23] = isFetching;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== commentsAvailable || $[26] !== data?.comments || $[27] !== id || $[28] !== t) {
    t9 = commentsAvailable ? data?.comments.map((t10, index_0) => {
      const {
        comment,
        submitted,
        rating: rating_0
      } = t10;
      return <div key={`reviews-${index_0}`} className="flex flex-col gap-1.5 py-2"><div className="flex justify-between"><Stars id={id} className="text-orange-600 *:size-4" rating={Number(rating_0)} /><span className="text-xs">{submitted}</span></div><p>{comment}</p></div>;
    }) : <p className="text-sm">{t("reviews.NoReviewsYet")}</p>;
    $[25] = commentsAvailable;
    $[26] = data?.comments;
    $[27] = id;
    $[28] = t;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t8 || $[31] !== t9) {
    t10 = <div className={t8}>{t9}</div>;
    $[30] = t8;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== commentsAvailable || $[34] !== page || $[35] !== pagesWithIndex || $[36] !== t) {
    t11 = commentsAvailable && <Pagination label={t("cyoAssortmentListPage.paginationLabel")} activePageIndex={pagesWithIndex.length <= page ? 0 : page} pages={pagesWithIndex} onPrevClick={() => setReviewsFilter(_temp2)} onNextClick={() => setReviewsFilter(_temp3)} />;
    $[33] = commentsAvailable;
    $[34] = page;
    $[35] = pagesWithIndex;
    $[36] = t;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== className || $[39] !== t10 || $[40] !== t11 || $[41] !== t7) {
    t12 = <div className={className}>{t7}{t10}{t11}</div>;
    $[38] = className;
    $[39] = t10;
    $[40] = t11;
    $[41] = t7;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  return t12;
};
function _temp(previousData) {
  return previousData;
}
function _temp2(prev) {
  return {
    ...prev,
    offset: prev.offset - OFFSET_STEP
  };
}
function _temp3(prev_0) {
  return {
    ...prev_0,
    offset: prev_0.offset + OFFSET_STEP
  };
}